define('app/services/empty',['angular', 'app/services/shared'], function (angular) {
  var module = angular.module('app.empty.service', ['app.shared'])

  module.factory('emptyService', ['$http', '$mdDialog', '$q', '$injector', 'sharedProperties', 'globalService', function ($http, $mdDialog, $q, $injector, sharedProperties, globalService) {
    var serveis = {
      consumeAction: function (action, id, elem, routeParams, evt) {
        if (false) {
            ;
        } else {
            setTimeout(function () {
                deferred.resolve({ processed: false, elem: null, error: null })
            })
        }
        return deferred.promise
      }
    }
    return serveis
  }])

  return module
})
;
